<template>
    <x-page title="Report Absensi">

        <template #header-actions>
            <x-back-button :disabled="isLoading" 
                :display-warning="false"
                :click-handler="router => router.replace('/admin/reports')" />
        </template>

        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Label">
                        <input class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan label group" />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Kategori">
                        <x-ajax-dropdown url="/api/group-categories"
                            label="label"
                            :allow-empty="true"
                            v-model="selectedCategory"
                            :query="{ without_global_scopes: 1 }"
                            class="form-control"
                            placeholder="Ketik label kategori" />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="[
            '#',
            'Label',
            'Kategori',
            'Deskripsi',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link :to="`/admin/reports/attendances/${resource.id}`" 
                        title="Klik untuk lihat detail">
                        {{ resource.label }}
                    </router-link>
                </td>
                <td class="nowrap">
                    {{ resource | get('category.label', '-') }}
                </td>
                <td class="nowrap">
                    <div v-html="$options.filters.nl2br(resource.description)" />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../../components/XAjaxDropdown.vue'
import XBackButton from '../../../components/XBackButton.vue'
import XFilterBox from '../../../components/XFilterBox.vue'
import XFormGroup from '../../../components/XFormGroup.vue'
import XPage from '../../../components/XPage.vue'
import XPagination from '../../../components/XPagination.vue'
import XTable from '../../../components/XTable.vue'
import { handleGeneralXhrError } from '../../../helpers'
import FilterableMixin from '../../../mixins/FilterableMixin'
import PaginationMixin from '../../../mixins/PaginationMixin'
import PermissionMixin from '../../../mixins/PermissionMixin'

const groupIds = $('meta[name="allowed-group-ids"]')

const defaultFilters = {
    category_id: null,
    ids: groupIds.length > 0 ? JSON.parse(groupIds.attr('content')) : null,
    search: null,
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XPage,
        XBackButton,
        XFilterBox,
        XFormGroup,
        XAjaxDropdown,
        XTable,
        XPagination
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
            selectedCategory: null,
        }
    },
    methods: {
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/groups', {
                params: route.query
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                    with: [
                        'category',
                    ],
                    without_global_scopes: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
        PermissionMixin,
    ],
    watch: {
        'filters.category_id': {
            handler(id) {
                this.syncFilterToProperty(id, 'selectedCategory', `/api/group-categories/${id}`)
            },
            immediate: true,
        },
        selectedCategory: {
            handler(resource) {
                this.syncPropertyToFilter(resource, 'category_id')
            },
            deep: true,
        },
    }
}
</script>